var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-top"}},[(_vm.showStatus)?_c('age-verification-status-view',{attrs:{"status":_vm.status},on:{"retry":_vm.onRetry}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }